import { newSlice,_fetchEntitiesService,_loadEvents,_createEntityService,_updateEntityService,_deleteEntityService} from "../../../redux/slices/common/sliceFunctions";

var entitiesName = 'pollContacts';

const entitiesSlice = newSlice(entitiesName);
const events = _loadEvents(entitiesSlice);

export const entitiesSelector = (state) => state[entitiesName];
export default entitiesSlice.reducer;

export function fetchPoolByContactService(dataSlice) {
  dataSlice.dataUrl.code="GET_POLL_BYCONTACT";
  return _fetchEntitiesService(dataSlice,events);
}
export function fetchEntitiesService(dataSlice) {
  dataSlice.dataUrl.code="GET_POLLCONTACT";
  return _fetchEntitiesService(dataSlice,events);
}

export function createEntityService(dataSlice) {
  dataSlice.dataUrl.code="POST_POLLCONTACT";
  return _createEntityService(dataSlice,events);
}

export function updateEntityService(dataSlice) {
  dataSlice.dataUrl.code="PUT_POLLCONTACT";
  dataSlice.dataUpdate.isPost=true;
  return _updateEntityService(dataSlice,events);
}

export function deleteEntityService(dataSlice) {
  dataSlice.dataUrl.code="DELETE_POLLCONTACT";
  return _deleteEntityService(dataSlice,events);
}